import structureFieldsQuery from "application/queries/structureFieldsQuery";

const searchForm = (id) => (
  `
  form(id: "${id}"){
    id
    name
    description
    confirmation
    literalButton
    siteId
    endDate
    oneAnswerPerUser
    anonymous
    iCanAnswer
    status
    mobileMedia{
      id
      url
      path
    }
    webMedia{
      id
      url
      path
    }
    ${structureFieldsQuery}
  }
  `
);

export default searchForm;
